import { Box, useColorMode, IconButton, Tooltip } from "@chakra-ui/react";
import { MoonIcon, SunIcon } from "@chakra-ui/icons";

const ColorModeToggle = () => {
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <Tooltip
      label={
        colorMode === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"
      }
    >
      <IconButton
        aria-label="Toggle color mode"
        icon={colorMode === "dark" ? <SunIcon /> : <MoonIcon />}
        onClick={toggleColorMode}
        variant="ghost"
        colorScheme="blue"
        size="md"
      />
    </Tooltip>
  );
};

export default ColorModeToggle;
